import NutritionInfoToggles from './NutritionInfoToggles';

export default NutritionInfoToggles;
